import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthDay", "weekDay"]

  frequency(event) {
    const weekly = event.target.value === "weekly"
    this.toggle(this.weekDayTarget, weekly)
    this.toggle(this.monthDayTarget, !weekly)
  }

  toggle(wrapper, on) {
    wrapper.classList.toggle("hidden", !on)
    wrapper.querySelectorAll("select").forEach((el) => {
      el.disabled = !on
      el.tomselect?.[on ? "enable" : "disable"]()
    })
  }
}
